import React from "react";
import creditCardIcon from "../../../../images/credit-card-icon.svg";
import googlePayIcon from "../../../../images/google-pay-icon.svg";
import applePayIcon from "../../../../images/apple-pay-mark.svg";
import PayPalLogo from "components/v3/paypal-logo/PayPalLogo";
import { PAYMENT_METHODS } from "common/constants/Constants";
import styles from "./styles.module.scss";

const ExistingPayment = (props) => {
    const {
        paymentMethod,
        cardInformation,
        onChangePaymentMethod
    } = props;

    return (
        <div className={ styles.existingPayment }>
            <PaymentMethod method={ paymentMethod } />
            <CreditCardNumber lastFourDigits={ cardInformation.lastFourDigits } />
            <button className={ styles.change } type="button" onClick={ onChangePaymentMethod }>Change</button>
        </div>
    );
};

const PaymentMethod = ({ method }) => {
    switch (method) {
        case PAYMENT_METHODS.STRIPE:
            return <img className={ styles.creditCardIcon } alt="" src={ creditCardIcon } />;
        case PAYMENT_METHODS.PAYPAL:
            return <PayPalLogo />;
        case PAYMENT_METHODS.GOOGLE:
            return <img className={ styles.googlePayIcon } alt="" src={ googlePayIcon } />;
        case PAYMENT_METHODS.APPLE:
            return <img className={ styles.applePayIcon } alt="" src={ applePayIcon } />;
        default:
            return <div className={ styles.paymentMethod }>{ method }</div>;
    }
};

const CreditCardNumber = ({ lastFourDigits }) => {
    if (!lastFourDigits) {
        return null;
    }

    return <div className={ styles.creditCardNumber }>xxxx - xxxx - xxxx - { lastFourDigits }</div>;
};

export default ExistingPayment;
